module.exports = __webpack_public_path__ + "static/img/blank_headPic.7daaa674.png";